export default __webpack_public_path__ + "static/media/group372-bw.41314087.svg";